import { fetchOneclubMoe } from "@/apis/oneclubMoe/base";
import type { GetMoeLoginUrlResponse } from "./types";

export const getMoeLoginUrl = (): Promise<GetMoeLoginUrlResponse> =>
  fetchOneclubMoe<GetMoeLoginUrlResponse>({
    url: "/prod/users/createOrgLoginForMoe",
    body: {
      clientid: import.meta.env.VITE_MOE_CLIENT_ID,
      params: "",
    },
  });
